// extracted by mini-css-extract-plugin
module.exports = {"folder-form":"FolderForm_folder-form__Q6R_9","footer":"FolderForm_footer__2JFMv","select":"FolderForm_select__2BbwH"};